export default {
  "root": "_root_fovf0_1",
  "input": "_input_fovf0_1",
  "slot": "_slot_fovf0_1",
  "arrow": "_arrow_fovf0_1",
  "--size-small": "_--size-small_fovf0_1",
  "--size-medium": "_--size-medium_fovf0_1",
  "--size-large": "_--size-large_fovf0_1",
  "--size-xlarge": "_--size-xlarge_fovf0_1",
  "--variant-faded": "_--variant-faded_fovf0_1",
  "--variant-headless": "_--variant-headless_fovf0_1",
  "--status-error": "_--status-error_fovf0_1",
  "--placeholder": "_--placeholder_fovf0_1",
  "--disabled": "_--disabled_fovf0_1",
  "--size-small--m": "_--size-small--m_fovf0_1",
  "--size-medium--m": "_--size-medium--m_fovf0_1",
  "--size-large--m": "_--size-large--m_fovf0_1",
  "--size-xlarge--m": "_--size-xlarge--m_fovf0_1",
  "--size-small--l": "_--size-small--l_fovf0_1",
  "--size-medium--l": "_--size-medium--l_fovf0_1",
  "--size-large--l": "_--size-large--l_fovf0_1",
  "--size-xlarge--l": "_--size-xlarge--l_fovf0_1",
  "--size-small--xl": "_--size-small--xl_fovf0_1",
  "--size-medium--xl": "_--size-medium--xl_fovf0_1",
  "--size-large--xl": "_--size-large--xl_fovf0_1",
  "--size-xlarge--xl": "_--size-xlarge--xl_fovf0_1"
};import "ni:sha-256;-UdEM0TmIVw1vdp1Uo7HUQBzuw_CqUCcms41eHOCDa8";